export default import.meta.ROLLUP_FILE_URL_6jJsJFqALfPLhO5QJBlJcw;